// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle__MenuToggle--2SsAS","open":"MenuToggle__open--2XIRG"};